module.exports = __webpack_public_path__ + "img/errorIcon.90497279.svg";